import {supportSvg as Icon__small__supportSvg} from '../Icon__small/Icon__small--support.js'

export var support = {
  name: 'support',
  category: 'icon',
  colorable: true,
  svg: Icon__small__supportSvg,
};
